module.exports = "<p>\n  dsgvo works!\n</p>\n"